"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[76],{

/***/ 5076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ VimeoSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_container__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2606);
/* harmony import */ var _components_vimeo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9972);
/* harmony import */ var _lib_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(608);




function VimeoSection(param) {
    let { data: { vimeoUrl , videoPreset , videoStartAtSecond  }  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_container__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        size: _lib_types__WEBPACK_IMPORTED_MODULE_3__/* .ContainerSize.wide */ .B.wide,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "lg:grid grid-cols-12 gap-1.5 md:gap-6",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "col-start-3 col-span-8 rounded-xl md:rounded-3xl overflow-hidden",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_vimeo__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    url: vimeoUrl,
                    preset: videoPreset,
                    start: videoStartAtSecond
                })
            })
        })
    });
}


/***/ })

}]);